import Styled from 'styled-components';

export const Container = Styled.div`
    padding: 1rem;
    background-color: #ffffff
`;